import(/* webpackMode: "eager", webpackExports: ["FooterSection"] */ "/var/www/pdfacture/app/[locale]/FooterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pdfacture/app/[locale]/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","displayName","Image","Fallback"] */ "/var/www/pdfacture/node_modules/@radix-ui/react-avatar/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Trigger","Group","Portal","Sub","RadioGroup","SubTrigger","displayName","SubContent","Content","Item","CheckboxItem","ItemIndicator","RadioItem","Label","Separator"] */ "/var/www/pdfacture/node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pdfacture/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pdfacture/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pdfacture/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/pdfacture/node_modules/react-complex-tree/lib/style-modern.css");
;
import(/* webpackMode: "eager" */ "/var/www/pdfacture/app/[locale]/globals.css");
;
import(/* webpackMode: "eager" */ "/var/www/pdfacture/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Oswald\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"font\"}");
;
import(/* webpackMode: "eager", webpackExports: ["LoginButton"] */ "/var/www/pdfacture/src/components/auth/LoginButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoutButton"] */ "/var/www/pdfacture/src/components/auth/LogoutButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavLinks"] */ "/var/www/pdfacture/src/components/layout/NavLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageDropdown"] */ "/var/www/pdfacture/src/components/locale/LanguageDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/var/www/pdfacture/src/components/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeDropdown"] */ "/var/www/pdfacture/src/components/theme/ThemeDropdown.tsx");
